import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Control, Errors } from 'react-redux-form';
import NativeDatePicker from './nativeDatePicker';
import Subtext from '../subText';
import ValidationIndicator from '../validationIndicator';
import { titleCase } from '../../../utils/titleCase';
import {
  getValidations,
  getValidationMessages,
} from '../../../validators/validators';
import { getFormData } from '../../../selectors/formSelector';
import {
  registerDefaultedField,
  clearDefaultedField,
} from '../../../actions/formTrackingActions';
import { runActionsAfterStep } from '../../../actions/formActions';
import { fieldHasValue } from '../../../utils/misc';

const errorComponentClassName = 'ltErrorText';

const controlHasError = ({
  valid,
  retouched,
  focus,
  touched,
  pristine,
  submitFailed,
  submitted,
}) => {
  let propertyEdited = touched || retouched;
  let propertySubmitted = submitFailed || submitted;
  let isStepLoad = !touched && submitted;
  return (
    !isStepLoad &&
    propertyEdited &&
    !pristine &&
    !valid &&
    (!focus || propertySubmitted)
  );
};

const NativeDatePickerRrf = ({
  step,
  dispatch,
  formData,
  autoFocus,
  warnings,
}) => {
  const [clearedDefaultedField, setClearedDefaultedField] =
    React.useState(false);

  let errorClassName =
    warnings && warnings[step.attributeid] ? 'ltHasWarning' : 'ltHasError';

  useEffect(() => {
    const initialLoadValue = formData?.[step.attributeid];
    if (fieldHasValue(initialLoadValue)) {
      dispatch(registerDefaultedField(step.attributeid, initialLoadValue));
    }
  }, []);

  const handleDateChange = () => {
    if (!clearedDefaultedField) {
      dispatch(clearDefaultedField(step.attributeid));
      setClearedDefaultedField(true);
    }

    if (step.actionsafterchange && step.actionsafterchange.length > 0) {
      dispatch(runActionsAfterStep(null, step));
    }
  };

  let ltFieldReadOnlyClassName =
    step.isFieldReadonly === true ? 'ltFieldReadOnly' : '';
  return (
    <div
      className={`ltFormGroupContent${titleCase(
        step.nodetype,
        0
      )} ${ltFieldReadOnlyClassName}`}
    >
      <Control
        aria-label={
          step.attributeDescriptiveName
            ? `Input for ${step.attributeDescriptiveName}`
            : null
        }
        id={`formData.${step.attributeid}`}
        model={`formData.${step.attributeid}`}
        component={NativeDatePicker}
        validators={getValidations(step.validation, step.formatter)}
        mapProps={{
          className: ({ fieldValue }) => {
            let classes = ['ltFormControl', step.attributeid];
            if (controlHasError(fieldValue)) {
              classes.push(errorClassName);
            }
            return classes.join(' ');
          },
          onupdate: (props) => {
            return (value) => {
              handleDateChange();
              props.onChange(value);
            };
          },
          onBlur: (props) => props.onBlur,
          hasError: ({ fieldValue }) => controlHasError(fieldValue),
          attributeid: step.attributeid,
          autoFocus: autoFocus,
          readOnly: step.isFieldReadonly === true,
          validation: step.validation,
        }}
      />
      <Control.text
        model={`formData.${step.attributeid}`}
        component={(props) => (
          <ValidationIndicator classExt={step.attributeid}>
            {props}
          </ValidationIndicator>
        )}
        mapProps={{
          fieldValue: (props) => props.fieldValue,
        }}
      />
      <Errors
        component={(props) => (
          <div
            className={`ltHasError ${errorComponentClassName} ${step.attributeid}`}
            /*eslint-disable react/no-multi-comp,react/no-danger*/
            dangerouslySetInnerHTML={{ __html: props.children }}
          />
        )}
        wrapper={(props) => <div className="errors">{props.children}</div>}
        show={(field) => controlHasError(field)}
        model={`formData.${step.attributeid}`}
        messages={getValidationMessages(step.validation)}
      />
      <Control.text
        model={`formData.${step.attributeid}`}
        component={(props) => (
          <Subtext
            text={step.help}
            forceShow={step.persistHelpText}
            classExt={step.attributeid}
          >
            {props}
          </Subtext>
        )}
        mapProps={{
          fieldValue: (props) => props.fieldValue,
        }}
      />
    </div>
  );
};

NativeDatePickerRrf.propTypes = {
  step: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  formData: PropTypes.object,
  autoFocus: PropTypes.bool,
  warnings: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    formData: getFormData(state),
  };
};

export default connect(mapStateToProps)(NativeDatePickerRrf);
